import React, { } from 'react';
import { Box, Card, CardBody, CardHeader, Heading, List, ListItem, UnorderedList } from '@chakra-ui/react';


const RodoPage: React.FC = () => {

    return <Box
        minHeight="100vh"
        width="100vw"
        backgroundImage="url('/images/cone.jpg')"
        backgroundSize="cover"
        backgroundPosition="center"
        display="flex"
        justifyContent="center"
        alignItems="center"
    >
        <Card
            display="flex"
            justifyContent="center"
            alignItems="center"
            shadow="none"
            padding="10"
            width="100%"
            maxWidth="90%"
            marginTop="20px"
            marginBottom="20px"
        >
            <CardHeader>
                <Heading size='md'>Zgoda na przetwarzanie danych osobowych</Heading>
            </CardHeader>
            <CardBody width="100%">
                Zgodnie z art. 6 ust. 1 lit. a oraz art. 13-14 Rozporządzenia Parlamentu Europejskiego i Rady (UE) 2016/679 z dnia 27 kwietnia 2016 r. w sprawie ochrony osób fizycznych w związku z przetwarzaniem danych osobowych i w sprawie swobodnego przepływu takich danych (RODO), wyrażam zgodę na przetwarzanie moich danych osobowych przez [Związek Harcerstwa Rzeczypospolitej] (dalej: Administrator), w celach związanych z procesem rejestracji instruktorskiej na rok 2025, wynikającej z Regulaminu Służby Instruktorskiej.
            </CardBody>
            <CardHeader>
                <Heading size='md'>Podstawowe informacje dotyczące przetwarzania danych osobowych:</Heading>
            </CardHeader>
            <CardBody width="100%">
                <Heading size='sm'>Administrator danych osobowych:</Heading>
                <Box p={4}>Administratorem Twoich danych osobowych jest Związek Harcerstwa Rzeczypospolitej z siedzibą w Warszawie na ul. Litewskiej 11/13.</Box>

                <Heading size='sm'>Cele przetwarzania danych:</Heading>
                <Box p={4}>Dane będą przetwarzane w celu przeprowadzenie procesu rejestracji instruktorek i instruktorów na rok 2025 zgodnie z Regulaminem Służby Instruktorskiej, realizacji ochrony małoletnich.</Box>

                <Heading size='sm'>Podstawa prawna przetwarzania:</Heading>
                <Box p={4}>Dane są przetwarzane na podstawie Twojej zgody, zgodnie z art. 6 ust. 1 lit. a RODO.</Box>

                <Heading size='sm'>Okres przechowywania danych:</Heading>
                <Box p={4}>Twoje dane osobowe będą przechowywane przez okres niezbędny do realizacji celów, dla których zostały zgromadzone, lub do czasu wycofania zgody, chyba że dalsze przechowywanie wynika z obowiązujących przepisów prawa.</Box>

                <Heading size='sm'>Twoje prawa:</Heading>
                <Box p={4}>Masz prawo do:
                    <UnorderedList>
                        <ListItem>dostępu do swoich danych,</ListItem>
                        <ListItem>sprostowania swoich danych,</ListItem>
                        <ListItem>usunięcia danych (prawo do bycia zapomnianym),</ListItem>
                        <ListItem>ograniczenia przetwarzania danych,</ListItem>
                        <ListItem>przeniesienia danych,</ListItem>
                        <ListItem>wniesienia sprzeciwu wobec przetwarzania,</ListItem>
                        <ListItem>wycofania zgody na przetwarzanie danych w dowolnym momencie, co nie wpływa na zgodność z prawem przetwarzania, którego dokonano na podstawie zgody przed jej wycofaniem,</ListItem>
                        <ListItem>wniesienia skargi do organu nadzorczego (Prezesa Urzędu Ochrony Danych Osobowych).</ListItem>
                    </UnorderedList>
                </Box>
                <Heading size='sm'>Dobrowolność podania danych:</Heading>
                <Box p={4}>Podanie danych jest dobrowolne, jednak niezbędne do korzystania z aplikacji i realizacji w/w procesu.</Box>

                <Heading size='sm'>Przekazywanie danych:</Heading>
                <Box p={4}>Twoje dane mogą być udostępniane wyłącznie podmiotom upoważnionym na mocy przepisów prawa lub na podstawie zawartych umów powierzenia przetwarzania danych.</Box>

            </CardBody>

        </Card>
    </Box>
};

export default RodoPage;
